export default "<slide-to></slide-to>";